let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gSKQp")).then(() => parcelRequire('5mgu9'));